// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2Lw3N","signatureBlock":"Footer_signatureBlock__3_3XC","signature":"Footer_signature__2pM3I"};